import { Component } from '@angular/core';
import { Platform, AlertController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { Contact } from '../pages/contact/contact';
import { Deelnemers } from '../pages/deelnemers/deelnemers';
import { OverPTRN } from '../pages/over-ptrn/over-ptrn';
import { Projectformat } from '../pages/projectformat/projectformat';
import { Werkwijze } from '../pages/werkwijze/werkwijze';
import { Aanmelden } from '../pages/aanmelden/aanmelden';
import { Presentaties } from '../pages/presentaties/presentaties';
import { VolgendeBijeenkomst } from '../pages/volgende-bijeenkomst/volgende-bijeenkomst';
import { Bijeenkomst } from '../pages/bijeenkomst/bijeenkomst';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage:any = HomePage;

    menuItems: any[] =
  [
    {id: 0, title: 'Home', content: 'home'},
    {id: 1, title: 'Over de PTRN', content: 'ptrn'},
    {id: 2, title: 'Contact', content: 'contact'},
    {id: 1, title: 'Deelnemers', content: 'deelnemers'},
    {id: 2, title: 'Werkwijze', content: 'werkwijze'},
    {id: 1, title: 'Projectformat', content: 'projectformat'},
    {id: 2, title: 'Bijeenkomsten', content: 'bijeenkomsten'},
    {id: 3, title: 'Presentaties', content: 'presentaties'},
    {id: 4, title: 'Aanmelden', content: 'aanmelden'},
    {id: 5, title: 'Volgende Bijeenkomst', content: 'volgende'}
  ];


  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private alertCtrl: AlertController) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      if(!platform.is('core') && !platform.is('tablet')) {
        this.alertCtrl.create({
          title: 'Mobiele Website',
          message: `Op het moment is er nog geen mobiele website beschikbaar. De website is slecht benaderbaar vanaf uw mobiel.
          Open de website op uw computer indien u een betere website wilt.`,
          buttons: [{text:'Ok', role: 'cancel'}]
        }).present();
      }
    });
  }

  showMenuItem(item: any) {
    switch(item ) {
      case 'contact' : {
        this.rootPage = Contact;
        break;
      }
      case 'ptrn' : {
        this.rootPage = OverPTRN;
        break;
      }
      case 'deelnemers' : {
        if(localStorage.getItem('ti:os:allow')) {
          this.rootPage = Deelnemers; break;
        } else {
            let prompt = this.alertCtrl.create({
            title: 'Login',
            message: 'Op deze pagina bevinden zich e-mail adressen. Vul de code in om deze te bekijken.',
            inputs: [
              {
                name: 'passcode',
                placeholder: 'Passcode',
                type: 'text'
              }
            ],
            buttons: [
              {
                text: 'Cancel',
                role: 'cancel',
                handler: data => {
                  console.log('Cancel clicked');
                }
              },
              {
                text: 'Continue',
                handler: data => {
                  if(data.passcode == '2093') {
                    localStorage.setItem("ti:os:allow", 'true');
                    this.rootPage = Deelnemers;
                  } else {
                    alert("Verkeerde code!");
                    prompt.present();
                  }
                }  
              }
            ]
          });
          prompt.present();
          break;
        }
      }
      case 'werkwijze' : {
        this.rootPage = Werkwijze;
        break;
      }
      case 'projectformat' : {
        this.rootPage = Projectformat;
        break;
      }
      case 'bijeenkomsten': {
        this.rootPage = Bijeenkomst;
        break;
      }
      case 'presentaties' : {
        this.rootPage = Presentaties;
        break;
      }
      case 'aanmelden' : {
        this.rootPage = Aanmelden;
        break;
      }

      case 'volgende' : {
        this.rootPage = VolgendeBijeenkomst;
        break;
      }

      default: {
        this.rootPage = HomePage;
        break;
      }
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts